import { Flex } from "@chakra-ui/react";
import { SectionHeader } from "components/SectionHeader";
import { Props } from "../../WebAnalytics.types";
import {
  CustomersByEmployeeSize,
  CustomersByGeography,
  CustomersByRevenueSize,
  SiteEngagementLift,
  Statistics,
  TopVisitedUrls,
  WebsiteVisits,
} from "./components";
import { BuyingGroupStatistics } from "./components/BuyingGroupStatistics";
import { BuyingGroupTopVisitedUrls } from "./components/BuyingGroupTopUrls";
import { CustomersMonitoredWithIntent } from "./components/CustomersMonitoredWithIntent/CustomersMonitoredWithIntent";
import { PersonaTopWebsiteVisitor } from "./components/PersonaTopWebsiteVisitor";

const Visualization = ({
  pixelId,
  accountView,
  campaignId,
  startDate,
  endDate,
  accountsIds,
  visitedPages,
  includeIspTraffic,
  includeKnownBotTraffic,
  includePotentialBotTraffic,
  personas,
}: Props) => {
  return (
    <Flex wrap="wrap">
      <Flex width="100%">
        <Statistics
          pixelId={pixelId}
          accountView={accountView}
          campaignId={campaignId}
          startDate={startDate}
          endDate={endDate}
          accountsIds={accountsIds}
          visitedPages={visitedPages}
          includeIspTraffic={includeIspTraffic}
          includeKnownBotTraffic={includeKnownBotTraffic}
          includePotentialBotTraffic={includePotentialBotTraffic}
          personas={personas}
        />
      </Flex>
      <Flex width="100%" wrap="wrap" gap={4}>
        <Flex width="100%">
          <WebsiteVisits
            pixelId={pixelId}
            accountView={accountView}
            campaignId={campaignId}
            startDate={startDate}
            endDate={endDate}
            accountsIds={accountsIds}
            visitedPages={visitedPages}
            includeIspTraffic={includeIspTraffic}
            includeKnownBotTraffic={includeKnownBotTraffic}
            includePotentialBotTraffic={includePotentialBotTraffic}
            personas={personas}
          />
        </Flex>
        {campaignId && (
          <Flex width="100%">
            <SiteEngagementLift
              pixelId={pixelId}
              campaignId={campaignId}
              includeIspTraffic={includeIspTraffic}
              includeKnownBotTraffic={includeKnownBotTraffic}
              includePotentialBotTraffic={includePotentialBotTraffic}
            />
          </Flex>
        )}
        <Flex width="100%" gap={4} minH="350px">
          <TopVisitedUrls
            pixelId={pixelId}
            accountView={accountView}
            campaignId={campaignId}
            startDate={startDate}
            endDate={endDate}
            accountsIds={accountsIds}
            visitedPages={visitedPages}
            includeIspTraffic={includeIspTraffic}
            includeKnownBotTraffic={includeKnownBotTraffic}
            includePotentialBotTraffic={includePotentialBotTraffic}
            personas={personas}
          />
          <CustomersByGeography
            pixelId={pixelId}
            accountView={accountView}
            campaignId={campaignId}
            startDate={startDate}
            endDate={endDate}
            accountsIds={accountsIds}
            visitedPages={visitedPages}
            includeIspTraffic={includeIspTraffic}
            includeKnownBotTraffic={includeKnownBotTraffic}
            includePotentialBotTraffic={includePotentialBotTraffic}
            personas={personas}
          />
        </Flex>
        <Flex width="100%" gap={4}>
          <CustomersByEmployeeSize
            pixelId={pixelId}
            accountView={accountView}
            campaignId={campaignId}
            startDate={startDate}
            endDate={endDate}
            accountsIds={accountsIds}
            visitedPages={visitedPages}
            includeIspTraffic={includeIspTraffic}
            includeKnownBotTraffic={includeKnownBotTraffic}
            includePotentialBotTraffic={includePotentialBotTraffic}
            personas={personas}
          />
          <CustomersByRevenueSize
            pixelId={pixelId}
            accountView={accountView}
            campaignId={campaignId}
            startDate={startDate}
            endDate={endDate}
            accountsIds={accountsIds}
            visitedPages={visitedPages}
            includeIspTraffic={includeIspTraffic}
            includeKnownBotTraffic={includeKnownBotTraffic}
            includePotentialBotTraffic={includePotentialBotTraffic}
            personas={personas}
          />
        </Flex>
        <SectionHeader>Buying Group Visitor Resolution</SectionHeader>
        <Flex width="100%" direction={"column"} gap={4}>
          <BuyingGroupStatistics
            pixelId={pixelId}
            accountView={accountView}
            campaignId={campaignId}
            startDate={startDate}
            endDate={endDate}
            accountsIds={accountsIds}
          />
          <Flex width="100%" gap={4} minH={350}>
            <BuyingGroupTopVisitedUrls
              pixelId={pixelId}
              accountView={accountView}
              campaignId={campaignId}
              startDate={startDate}
              endDate={endDate}
              accountsIds={accountsIds}
              visitedPages={visitedPages}
              includeIspTraffic={includeIspTraffic}
              includeKnownBotTraffic={includeKnownBotTraffic}
              includePotentialBotTraffic={includePotentialBotTraffic}
              personas={personas}
            />
          </Flex>
          <Flex width="100%" gap={4}>
            <PersonaTopWebsiteVisitor
              pixelId={pixelId}
              accountView={accountView}
              campaignId={campaignId}
              startDate={startDate}
              endDate={endDate}
              accountsIds={accountsIds}
              visitedPages={visitedPages}
              includeIspTraffic={includeIspTraffic}
              includeKnownBotTraffic={includeKnownBotTraffic}
              includePotentialBotTraffic={includePotentialBotTraffic}
              personas={personas}
            />
            <CustomersMonitoredWithIntent
              pixelId={pixelId}
              accountView={accountView}
              campaignId={campaignId}
              startDate={startDate}
              endDate={endDate}
              accountsIds={accountsIds}
              visitedPages={visitedPages}
              includeIspTraffic={includeIspTraffic}
              includeKnownBotTraffic={includeKnownBotTraffic}
              includePotentialBotTraffic={includePotentialBotTraffic}
              personas={personas}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export { Visualization };
